import { GetterTree } from 'vuex';
import { RootState } from '../types';
import { ActiveWorkspaceState, AuthState, Company } from './types';

export const getters: GetterTree<AuthState, RootState> = {
    accessToken(state): string {
        return state ? state.accessToken : null;
    },
    loggedIn(state): boolean {
        return state ? state.loggedIn : false;
    },
    username(state): string {
        if (state) {
            if (state.username) return state.username;
            else if (state.email) return state.email;
            else return 'Desconhecido';
        } else {
            return 'Desconhecido';
        }
    },
    roles(state): Array<string> {
        return state && state.activeCompany && state.activeCompany.roles ? state.activeCompany.roles : [];
    },
    workspaces(state): Array<Company> {
        if (!state || state.companies.length === 0) {
            return [];
        }
        return state.companies.filter(w => w.companyKey !== state.activeCompany.company.toString()).sort((s1, s2) => {return s1.name.localeCompare(s2.name); } );
    },
    activeWorkspace(state): ActiveWorkspaceState {
        if (!state) {
            return null;
        }
        if (state.activeCompany) {
            return state.activeCompany;
        }
        return null;
    },
    email(state): string {
        if (state) {
            return state.email ? state.email : null;
        }
        return null;
    },
    isB2B(state): boolean {
        return state && state.isB2B;
    }
};
